/*
*
* Will load the href Url per Json, in case this url has been already loaded or available in any way it will load it from
* the storage.
*
*/
(() => {
    class Page {
        constructor() {
            /* this keeps the storage of this Interface */
            this.Storage    = new App.Interface.Storage('pages');
            this.selectors  = [];
            this.callbacks  = {};
            this
                .addSelector('a[target=ajax]')
                .bind()
            ;
        }

        /*
        * Add Page to bundle
        *
        * @return
        */
        add(page) {
            this.Storage.set(page.url, page);
            return this;
        }

        /*
        * Add Selector
        *
        * @return
        */
        addSelector(selector) {
            this.selectors.push(selector);
            return this;
        }

        /**
         * Remove file resources Urls
         */
        removeResources(overlay = 'page') {
            $('.app-resource-' + overlay).remove();
            return this;
        }

        /**
         * Push Page into history
         *
         * @return
         */
        pushPage(page) {
            history.replaceState(page, page.title, page.url);
            App.Layout.setBrand(page.brand);
            return this;
        }

        /**
         * Push Page into history
         *
         * @param file Javascript file to append
         * @param path
         * @param format
         * @param state
         *
         * @return Promise
         */
        getScript(file, path = '/assets/js/', format = '.js', state = false) {
            let fileName    = path + file + format;
            let classes     = [
                this.stateClass(state),
                'app-resource-script',
            ];

            return new Promise((resolve, reject) => {
                /* Check if file already exists */
                if (document.querySelector('script[src^="' + fileName + '"]:not(.app-prefetch-resource)'))
                    return resolve(fileName);

                /* Create element */
                let script = document.createElement('script');
                script.type         = 'text/javascript';
                script.src          = state === 'page' ? fileName : [fileName, App.Setting('cache_bust')].join('?');
                script.className    = classes.join(' ');
                script.onload  = () => resolve(fileName);
                script.onerror = () => reject('Error loading resource: ' + fileName);
                document.head.appendChild(script);
            });
        }

        /**
         * Push Page into history
         *
         * @param file      CSS Style file to append
         * @param path      Path to file
         * @param format
         * @param state
         *
         * @return Promise
         */
        getStyle(file, path = '/assets/css/', format = '.css', state = false) {
            let fileName = path + file + format;

            /* Check if file already exists */
            if (document.querySelector('link[rel=stylesheet][href^="' + fileName + '"]:not(.app-prefetch-resource)'))
                return this;

            let classes = [
                this.stateClass(state),
                'app-resource-stylesheet',
            ];

            return new Promise((resolve, reject) => {
                /* Create element */
                let link = document.createElement('link');
                link.type       = 'text/css';
                link.rel        = 'stylesheet';
                link.href       = state === 'page' ? fileName : [fileName, App.Setting('cache_bust')].join('?');
                link.className  = classes.join(' ');
                link.onload  = () => resolve(fileName);
                link.onerror = () => reject('Error loading resource: ' + fileName);
                document.head.appendChild(link);
            });
        }

        stateClass(state) {
            switch (state) {
                case 'page' :
                    return 'app-resource-page';
                case 'component' :
                    return 'app-resource-component';
                case 'popup' :
                    return 'app-resource-popup';
                default:
                    return 'app-resource';
            }
        }

        prefetchStyle(file) {
            this.prefetchFile(file, 'text/css');
            return this;
        }

        prefetchScript(file) {
            this.prefetchFile(file, 'script');
            return this;
        }

        prefetchFile(file, type) {
            let link = document.createElement('link');
            type === 'script' ? link.as = type : link.type = type;
            link.rel        = 'prefetch'; // subresource
            link.href       = file;
            link.className  = 'app-resource app-prefetch-resource';
            document.head.appendChild(link);
            return this;
        }

        /**
         * Get content from Url
         *
         * @param url Url to get
         *
         * @param overlay
         * @return
         */
        async get(url, overlay = 'page') {
            this.removeResources(overlay);
            let item = this.Storage.get(url);
            if (!item) item = await this.request(url);
            return item;
        }

        /**
         * Post content from Url
         * @param url Url to get
         * @param data Payload to send
         * @return
         */
        post(url, data) {
            return this.request(url, 'POST', data);
        }

        load(url, normalize = true) {
            App.Page.get(url).then(Page => App.Layout.load(Page, normalize));
            return this;
        }

        /**
         * Create AjaxRequest
         *
         * @param url Url for request
         * @param method Request Method
         * @param data Values
         *
         * @return
         */
        async request(url, method = 'GET', data = {}) {
            const Page = new App.Entities.Page();
            return new Promise((resolve, reject) => {
                $.ajax({
                    accepts:    {dynamic: 'application/json, application/xml, text/html'},
                    method:     method,
                    url:        url,
                    dataType:   'dynamic',
                    data:       data,
                    async:      true,
                    converters: {
                        'text dynamic': function(result) {
                            return result;
                        }
                    },
                    fail: (xhr, status, error) => {
                        Page.setTitle(status);
                        Page.setContent(error !== '' ? error : __('GLOBAL.ERROR'));
                        reject(Page);
                    },
                    error: (xhr, status, error) => {
                        Page.setTitle(__('DEFAULT.STATIC.PAGE.TITLE.DEFAULT_NOTFOUND'));
                        Page.setContent(error !== '' ? error : __('DEFAULT.404.TEXT'));
                        reject(Page);
                        // Render Notification on error
                        try {
                            const json = JSON.parse(xhr.responseText);
                            if (json.notifications !== undefined) {
                                App.Interface.Notification.setFromBundle(json.notifications);
                            }
                        } catch(e) {}
                    },
                    success: (response, status, xhr) => {
                        if (status === 'success') {
                            try {
                                var json = jQuery.parseJSON(response);
                                if(typeof json =='object') {
                                    if (json.redirect) {
                                        window.location.href = json.redirect;
                                        return;
                                    }
                                    Page.merge(json);
                                    Page.url        = url;
                                    Page.variables  = json.globalAttributes.page || json.globalAttributes;
                                    Page.buttons    = json.buttons;
                                }
                            } catch(e) {
                                Page.url        = url;
                                Page.content    = response;
                            }

                            // Save page in the cache
                            if (Page.type === 'static' && method === 'GET') {
                                this.add(Page);
                            }

                            // do callbacks for this url
                            if (this.callbacks[url] !== undefined) {
                                this.callbacks[url].forEach((action, index) => {
                                    action.callback(Page, method);
                                    // if it only once, remove element from bundle
                                    if (action.once) this.callbacks[url] = this.callbacks[url].splice(index, 1);
                                });
                            }
                            resolve(Page);
                        } else {
                            new Error('Error loading page "' + url + '" with METHOD: ' + method);
                        }
                    }
                });
            });
        }

        registerCallback(url, callback, once = false) {
            if (this.callbacks[url] === undefined) this.callbacks[url] = [];
            this.callbacks[url].push({
                once:       once,
                callback:   callback,
            });
            return this;
        }

        bind() {
            App.Layout.body.on('click', this.selectors.join(', '), function(e) {
                let element = $(this);
                let href = element.attr('href');
                if (element.attr('target') !== '_blank' && href !== undefined) {
                    e.preventDefault();
                    App.Page.get(href).then(Page => App.Layout.load(Page));
                }
            });
        }
    }
    /* Load global class */
    App.Page = new Page();
})();
